// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-form-actions-default[data-v-dd1d851e]{display:flex;flex-direction:column;gap:var(--spacing-sm-3)}@media(min-width:768px){.base-form-actions-default[data-v-dd1d851e]{flex-direction:row}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
